// extracted by mini-css-extract-plugin
export default {"link":"_ba00f4ec"};